import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  ExternalManagedPaymentServicesDetailsResponseSchema,
  ExternalManagedPaymentServicesDetailsResponseType,
  GetExternalManagedPaymentServicesDetailsRequestSchema,
  GetExternalManagedPaymentServicesDetailsRequestType
} from '../../../services/NwExternalPaymentsServices/APIService/types';

import { useNwExternalPaymentsService } from '../useNwExternalPaymentsService';

interface UseGetExternalManagedPaymentServicesDetailsApiInterface {
  getExternalManagedPaymentServicesDetailsApi: (
    input: GetExternalManagedPaymentServicesDetailsRequestType
  ) => Promise<ExternalManagedPaymentServicesDetailsResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useGetExternalManagedPaymentServicesDetailsApi =
  (): UseGetExternalManagedPaymentServicesDetailsApiInterface => {
    const { nwExternalPaymentsServiceInstance } = useNwExternalPaymentsService();

    const getExternalManagedPaymentServicesDetails = (
      requestObject: GetExternalManagedPaymentServicesDetailsRequestType
    ) => {
      try {
        GetExternalManagedPaymentServicesDetailsRequestSchema.parse(
          requestObject
        );
      } catch (error) {
        console.error('Invalid request object:', error);
        throw error;
      }

      return nwExternalPaymentsServiceInstance
        .getExternalManagedPaymentServicesDetails(requestObject)
        .then((response) => {
          try {
            ExternalManagedPaymentServicesDetailsResponseSchema.parse(response);
          } catch (error) {
            console.error('Invalid response object:', error);
            throw error;
          }
          return response;
        });
    };

    const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
      getExternalManagedPaymentServicesDetails,
      {
        mutationKey: ['getExternalManagedPaymentServicesDetailsApi']
      }
    );

    return {
      getExternalManagedPaymentServicesDetailsApi: mutateAsync,
      isLoading,
      isError,
      error: error ? getAPIErrorMessage(error) : null,
      status,
      reset
    };
  };

export { useGetExternalManagedPaymentServicesDetailsApi };
